// extracted by mini-css-extract-plugin
module.exports = {"wd70yos":"wd70yos"};